import { render } from "./EmployeeViewPendingRequest.vue?vue&type=template&id=36f9a502"
import script from "./EmployeeViewPendingRequest.vue?vue&type=script&lang=js"
export * from "./EmployeeViewPendingRequest.vue?vue&type=script&lang=js"

import "./EmployeeViewPendingRequest.vue?vue&type=style&index=0&id=36f9a502&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__